import React from "react";
import { Span, SpanProps } from "../../";
import { escapeStringRegex } from "../../utils";

export type HighlighterProps = {
  /** A string that needs to be highlighted */
  highlight: string;
  /** Span props of highlighted string  */
  highlightTextProps?: SpanProps;
  /** A text that containts highlighted string*/
  text: string;
  /** Span props of text   */
  textProps?: SpanProps;
  /** Highlight unmatched string instead of matched one */
  reverse?: boolean;
};

export const Highlighter: React.FC<HighlighterProps> = ({
  highlight = "",
  text = "",
  highlightTextProps,
  textProps,
  reverse,
  ...props
}) => {
  const escapedText = escapeStringRegex(highlight);
  const parts = text.split(new RegExp(`(${escapedText})`, "gi"));

  function renderHighlightedString(text, key) {
    return (
      <Span key={key} fontWeight="bold" {...highlightTextProps}>
        {text}
      </Span>
    );
  }

  return (
    <Span {...textProps} {...props}>
      {parts.map((part, idx) =>
        reverse
          ? part.toLowerCase() === highlight.toLowerCase()
            ? part
            : renderHighlightedString(part, idx)
          : part.toLowerCase() === highlight.toLowerCase()
          ? renderHighlightedString(part, idx)
          : part
      )}
    </Span>
  );
};

Highlighter.displayName = "Highlighter";

export default Highlighter;
